import { runValidators, getValidators, getValidatorsIsValid } from '@/util/validation'
export default {
    data() {
        return {

        }
    },
    mounted() {
        //for (var prop in this.$data) {
        //    if (Object.prototype.hasOwnProperty.call(this.$data[prop], 'validators') == true) {
        //        this[prop + 'TestMethod'] = () => { console.log(prop + 'TestMethod') }
        //    }
        //}
    },
    methods: {
        getValidatorInvalidFeedback(obj, prop) {
            let validators = getValidators(obj, prop)
            if (validators) {
                return validators.inValidFeedback
            }
            return null
        },
        getValidatorIsValid(obj, prop) {
            let validators = getValidators(obj, prop)
            if (validators) {
                return validators.isValid
            }
            return false
        }
    }
}